import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { saveCompany } from "../../services/companyService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import { Table } from "semantic-ui-react";
import TableTitle from "../common/tableTitle";
import Currency from "../common/currency";
import { Link } from "react-router-dom";

class CompanyForm extends Form {
  state = {
    data: {
      name: "",
      address: "",
      phone: "",
      p_o_box: "",
      fullname: "",
      email: "",
      password: "",
      linked_to: "",
    },
    errors: {},
    linked_to_options: [
      { id: 0, name: "Select option" },
      { id: 1, name: "JV" },
      { id: 2, name: "SCRAP" },
    ],
  };

  schema = {
    id: Joi.string(),
    name: Joi.string().required().label("Company name"),
    address: Joi.string().required().label("Address"),
    phone: Joi.string().required().label("phone"),
    p_o_box: Joi.string().label("P O Box"),
    fullname: Joi.string().required().label("Fullname"),
    email: Joi.string().required().label("Email"),
    password: Joi.string().min(8).required().label("Password"),
    linked_to: Joi.allow("").label("Linked to"),
  };

  doSubmit = async () => {
    try {
      this.setState({ blocking: true });
      await saveCompany(this.state.data);
      toast.success("Company has been added successfully.");
      this.setState({ blocking: false });
      this.props.history.push("/companies");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        if (ex.response.data.errors.address)
          errors.address = ex.response.data.errors.address;

        if (ex.response.data.errors.phone)
          errors.phone = ex.response.data.errors.phone;

        if (ex.response.data.errors.p_o_box)
          errors.p_o_box = ex.response.data.errors.p_o_box;

        if (ex.response.data.errors.fullname)
          errors.fullname = ex.response.data.errors.fullname;

        if (ex.response.data.errors.email)
          errors.email = ex.response.data.errors.email;

        if (ex.response.data.errors.password)
          errors.password = ex.response.data.errors.password;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  render() {
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Add company</h1>
        <button
          className="btn btn--secondary"
          onClick={() => this.props.history.push("/companies")}
        >
          Back
        </button>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Add company</h3>
              <p>Provide the information below to add the company.</p>
              {this.renderInput("name", "Name", "text")}
              {this.renderInput("address", "Address", "text")}
              {this.renderInput("phone", "Phone", "text")}
              {this.renderInput("p_o_box", "P O Box", "text")}
              {this.renderInput("fullname", "User name", "text")}
              {this.renderInput("email", "Email", "text")}
              {this.renderInput("password", "Password", "password")}
              {this.renderSelect(
                "linked_to",
                "Linked to",
                this.state.linked_to_options
              )}

              {this.renderButton("Save")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default CompanyForm;
